/* The loading screen: a progress ring that fills as the deck is built. */

.boot {
  position: fixed;
  inset: 0;
  z-index: 90;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: linear-gradient(180deg, #fbfdfc 0%, #edf4f0 100%);
  transition:
    opacity 0.7s var(--ease-soft),
    visibility 0.7s;
}

.gone {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.mark {
  filter: drop-shadow(0 10px 26px rgba(16, 48, 34, 0.1));
}

.ring {
  transition: stroke-dashoffset 0.5s var(--ease-soft);
}

.title {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.03em;
  margin-top: 6px;
}

.sub {
  font-size: 14px;
  color: var(--ink-2);
  letter-spacing: -0.01em;
  min-height: 20px;
}
